// extracted by mini-css-extract-plugin
export default {"root":"logo_root__PimwK"};